import React, { Fragment } from 'react';
import InputMask from 'react-input-mask';
import { cnpj as cnpjValidator } from 'cpf-cnpj-validator';
import { Redirect } from 'react-router';
import axios from 'axios';
import './App.css';

import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Checkbox,
} from '@material-ui/core/';

import logo from './assets/logo-mandae.png';

import brasil from './assets/brasil.json';

class MainPage extends React.Component {
  state = {
    success: false,
    nome: '',
    email: '',
    estado: '',
    cidade: '',
    telefone: '',
    empresa: '',
    cnpj: '',
    envio: '0-200',
    cargo: '',
    url: '',
    termos: false,
    comunicados: false,
    estados: [
      { value: '', label: 'Selecione um estado' },
      { value: 'AC', label: 'Acre' },
      { value: 'AL', label: 'Alagoas' },
      { value: 'AP', label: 'Amapá' },
      { value: 'AM', label: 'Amazonas' },
      { value: 'BA', label: 'Bahia' },
      { value: 'CE', label: 'Ceará' },
      { value: 'DF', label: 'Distrito Federal' },
      { value: 'ES', label: 'Espírito Santo' },
      { value: 'GO', label: 'Goiás' },
      { value: 'MA', label: 'Maranhão' },
      { value: 'MT', label: 'Mato Grosso' },
      { value: 'MS', label: 'Mato Grosso do Sul' },
      { value: 'MG', label: 'Minas Gerais' },
      { value: 'PA', label: 'Pará' },
      { value: 'PB', label: 'Paraíba' },
      { value: 'PR', label: 'Paraná' },
      { value: 'PE', label: 'Pernambuco' },
      { value: 'PI', label: 'Piauí' },
      { value: 'RJ', label: 'Rio de Janeiro' },
      { value: 'RN', label: 'Rio Grande do Norte' },
      { value: 'RS', label: 'Rio Grande do Sul' },
      { value: 'RO', label: 'Rondônia' },
      { value: 'RR', label: 'Roraima' },
      { value: 'SC', label: 'Santa Catarina' },
      { value: 'SP', label: 'São Paulo' },
      { value: 'SE', label: 'Sergipe' },
      { value: 'TO', label: 'Tocantins' },
    ],
    cidades: [],
    envios: [
      { value: '0-200', label: 'Até 200 encomendas/mês' },
      { value: '201-350', label: 'De 201 a 350 encomendas/mês' },
      { value: '351-750', label: 'De 351 a 750 encomendas /mês' },
      { value: '751-1250', label: 'De 751 a 1250 encomendas/mês' },
      { value: '1251-2000', label: 'De 1251 a 2000 encomendas/mês' },
      { value: '2001', label: 'Acima de 2001 encomendas/mês' },
    ],
    cargos: [
      { value: 'CEO/Sócio', label: 'CEO/Sócio' },
      {
        value: 'Diretor/gerente/coordenador de logística',
        label: 'Diretor/gerente/coordenador de logística',
      },
      {
        value: 'Diretor/gerente/coordenador de e-commerce',
        label: 'Diretor/gerente/coordenador de e-commerce',
      },
      { value: 'CFO', label: 'CFO' },
      {
        value: 'Analista de e-commerce/logística',
        label: 'Analista de e-commerce/logística',
      },
      { value: 'Outros', label: 'Outros' },
    ],
    formSubmitted: false,
    errors: {
      cnpj: true,
      nome: true,
      email: true,
      empresa: true,
      estado: true,
      cidade: true,
      cargo: true,
    },
  };

  componentDidMount() {
    var rdScript = document.createElement('script');
    rdScript.src =
      'https://d335luupugsy2.cloudfront.net/js/integration/stable/rd-js-integration.min.js';
    document.getElementsByTagName('body')[0].appendChild(rdScript);

    document.querySelector('body').classList.remove('sucesso');
    document.querySelector('body').classList.remove('welcome');
  }

  handleName = (text) => {
    this.setState({ nome: text });

    if (text) {
      this.setState(({ errors }) => ({
        errors: { ...errors, nome: false },
      }));
    }
  };

  handleChangeEstado = (event) => {
    this.setState({ estado: event.target.value }, () => {
      this.getCidades();
    });

    if (event) {
      this.setState(({ errors }) => ({
        errors: { ...errors, estado: false },
      }));
    }
  };

  handleCidade = (text) => {
    this.setState({ cidade: text });

    if (text) {
      this.setState(({ errors }) => ({
        errors: { ...errors, cidade: false },
      }));
    }
  };

  handleEmpresa = (text) => {
    this.setState({ empresa: text });

    if (text) {
      this.setState(({ errors }) => ({
        errors: { ...errors, empresa: false },
      }));
    }
  };

  handleCargo = (text) => {
    this.setState({ cargo: text });

    if (text) {
      this.setState(({ errors }) => ({
        errors: { ...errors, cargo: false },
      }));
    }
  };

  handleCNPJ = (text) => {
    this.setState({ cnpj: text });

    if (text) {
      const cnpjValido = cnpjValidator.isValid(text);
      if (cnpjValido) {
        this.setState(({ errors }) => ({
          errors: { ...errors, cnpj: false },
        }));
      } else {
        this.setState(({ errors }) => ({
          errors: { ...errors, cnpj: 'invalid' },
        }));
      }
    }
  };

  handleChangeTermos = (event) => {
    this.setState({ termos: event.target.value });
  };

  handleTermos = () => {
    const termos = this.state.termos;
    this.setState({ termos: !termos });
  };

  handleComunicados = () => {
    const comunicados = this.state.comunicados;
    this.setState({ comunicados: !comunicados });
  };

  getCidades = () => {
    this.setState({ cidades: brasil[this.state.estado].cidades });
  };

  removerAcento = (text) => {
    text = text.replace(new RegExp('[ÁÀÂÃ]', 'g'), 'A');
    text = text.replace(new RegExp('[ÉÈÊ]', 'g'), 'E');
    text = text.replace(new RegExp('[ÍÌÎ]', 'g'), 'I');
    text = text.replace(new RegExp('[ÓÒÔÕ]', 'g'), 'O');
    text = text.replace(new RegExp('[ÚÙÛ]', 'g'), 'U');
    text = text.replace(new RegExp('[Ç]', 'g'), 'C');
    text = text.replace(new RegExp('[áàâã]', 'g'), 'a');
    text = text.replace(new RegExp('[éèê]', 'g'), 'e');
    text = text.replace(new RegExp('[íìî]', 'g'), 'i');
    text = text.replace(new RegExp('[óòôõ]', 'g'), 'o');
    text = text.replace(new RegExp('[úùû]', 'g'), 'u');
    text = text.replace(new RegExp('[ç]', 'g'), 'c');

    return text;
  };

  checkIsValidEmail = (text) => {
    this.setState({ email: text });

    // eslint-disable-next-line
    let regEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (regEmail.test(text)) {
      this.setState(({ errors }) => ({
        errors: { ...errors, email: false },
      }));
    } else {
      this.setState(({ errors }) => ({
        errors: { ...errors, email: 'invalid' },
      }));
    }
  };

  enviarForm = () => {
    this.setState({ formSubmitted: true });
    const {
      nome,
      email,
      empresa,
      cnpj,
      estado,
      cidade,
      cargo,
      telefone,
      envio,
      url,
    } = this.state;

    if (
      nome !== '' &&
      email !== '' &&
      empresa !== '' &&
      cnpj !== '' &&
      estado !== '' &&
      cidade !== '' &&
      cargo !== ''
    ) {
      const cnpjValido = cnpjValidator.isValid(cnpj);
      if (cnpjValido) {
        const data = {
          nome,
          email,
          telefone,
          empresa,
          cnpj,
          url,
          'cargo selec': cargo,
          'estado uf': estado,
          'lista cidades': this.removerAcento(cidade),
          cidade_coleta: this.removerAcento(cidade),
          flag: 'nuvemshop',
          identificador: 'quero-contratar-nuvemshop',
          token_rdstation: 'dcaf7bbbb433c6c2393ce2f21675f050',
          'encomendas/mês': envio,
        };

        axios
          .post('https://www.rdstation.com.br/api/1.3/conversions', data)
          .then((response) => {
            this.setState({ success: true });
          })
          .catch((error) => {
            alert('Houve um problema ao cadastrar, favor entrar em contato');
          });
      } else {
        this.setState({ errors: { ...this.state.errors, cnpj: 'invalid' } });
      }
    } else {
      if (cnpj === '') {
        this.setState(({ errors }) => ({
          errors: { ...errors, cnpj: 'required' },
        }));
      }
      if (nome === '') {
        this.setState(({ errors }) => ({
          errors: { ...errors, nome: 'required' },
        }));
      }

      if (email === '') {
        this.setState(({ errors }) => ({
          errors: { ...errors, email: 'required' },
        }));
      }
      if (empresa === '') {
        this.setState(({ errors }) => ({
          errors: { ...errors, empresa: 'required' },
        }));
      }
      if (estado === '') {
        this.setState(({ errors }) => ({
          errors: { ...errors, estado: 'required' },
        }));
      }
      if (cidade === '') {
        this.setState(({ errors }) => ({
          errors: { ...errors, cidade: 'required' },
        }));
      }
      if (cargo === '') {
        this.setState(({ errors }) => ({
          errors: { ...errors, cargo: 'required' },
        }));
      }

      setTimeout(() => {
        console.log(this.state.errors);
      }, 5000);
    }
  };

  renderData() {
    return this.state.success !== true ? (
      <Fragment>
        <img src={logo} alt='' id='logo' />
        <h2>
          Para ser contatado pela Mandaê preencha aqui os dados da sua empresa
        </h2>
        <div className='fields'>
          <div className='field'>
            <TextField
              variant='filled'
              required
              id='nome'
              label='Nome completo'
              name='nome'
              autoFocus
              fullWidth
              onChange={(evt) => this.handleName(evt.target.value)}
              autoComplete='off'
            />
            {this.state.formSubmitted !== false ? (
              this.state.errors.nome ||
              this.state.errors.nome === 'required' ? (
                <FormControl error>
                  <FormHelperText>Campo obrigatório</FormHelperText>
                </FormControl>
              ) : (
                ''
              )
            ) : (
              <FormControl>
                <FormHelperText>&nbsp;</FormHelperText>
              </FormControl>
            )}
          </div>
          <div className='field'>
            <TextField
              variant='filled'
              required
              id='email'
              label='Email'
              name='email'
              autoFocus
              fullWidth
              onChange={(evt) => this.checkIsValidEmail(evt.target.value)}
              autoComplete='off'
            />
            {this.state.formSubmitted !== false ? (
              this.state.errors.email === true ||
              this.state.errors.email === 'required' ||
              this.state.errors.email === 'invalid' ? (
                <FormControl error>
                  <FormHelperText>
                    {' '}
                    {this.state.errors.email === 'required'
                      ? 'Campo obrigatório'
                      : 'E-mail inválido'}{' '}
                  </FormHelperText>
                </FormControl>
              ) : (
                ''
              )
            ) : (
              <FormControl>
                <FormHelperText>&nbsp;</FormHelperText>
              </FormControl>
            )}
          </div>
        </div>

        <div className='fields'>
          <div className='field'>
            <FormControl variant='filled'>
              <InputLabel id='label-estado'>Estado *</InputLabel>
              <Select
                labelId='label-estado'
                id='estado'
                value={this.state.estado}
                onChange={(evt) => this.handleChangeEstado(evt)}
                fullWidth
                required
              >
                {this.state.estados.map((estado) => (
                  <MenuItem key={estado.value} value={estado.value}>
                    {' '}
                    {estado.label}
                  </MenuItem>
                ))}
              </Select>

              {this.state.formSubmitted !== false ? (
                this.state.errors.estado ||
                this.state.errors.estado === 'required' ? (
                  <FormControl error>
                    <FormHelperText>Campo obrigatório</FormHelperText>
                  </FormControl>
                ) : (
                  ''
                )
              ) : (
                <FormControl>
                  <FormHelperText>&nbsp;</FormHelperText>
                </FormControl>
              )}
            </FormControl>
          </div>

          <div className='field'>
            <FormControl variant='filled'>
              <InputLabel id='label-cidade'>Cidade *</InputLabel>
              <Select
                labelId='label-cidade'
                id='cidade'
                required
                value={this.state.cidade}
                onChange={(evt) => this.handleCidade(evt.target.value)}
                fullWidth
              >
                {this.state.cidades.map((cidade) => (
                  <MenuItem key={cidade} value={cidade}>
                    {' '}
                    {cidade}
                  </MenuItem>
                ))}
              </Select>

              {this.state.formSubmitted !== false ? (
                this.state.errors.cidade ||
                this.state.errors.cidade === 'required' ? (
                  <FormControl error>
                    <FormHelperText>Campo obrigatório</FormHelperText>
                  </FormControl>
                ) : (
                  ''
                )
              ) : (
                <FormControl>
                  <FormHelperText>&nbsp;</FormHelperText>
                </FormControl>
              )}
            </FormControl>
          </div>

          <div className='field'>
            <InputMask
              mask='(99) 999999999'
              value={this.state.telefone}
              disabled={false}
              maskChar=''
              onChange={(evt) => this.setState({ telefone: evt.target.value })}
              autoComplete='off'
            >
              {() => (
                <TextField
                  variant='filled'
                  id='telefone'
                  label='Telefone'
                  name='telefone'
                  autoFocus
                  fullWidth
                />
              )}
            </InputMask>
          </div>
        </div>

        {/* Nome da empresa | CNPJ | Envios por dia */}
        <div className='fields'>
          <div className='field'>
            <TextField
              variant='filled'
              required
              id='empresa'
              label='Empresa'
              name='empresa'
              autoFocus
              fullWidth
              onChange={(evt) => {
                this.handleEmpresa(evt.target.value);
              }}
              autoComplete='off'
            />
            {this.state.formSubmitted !== false ? (
              this.state.errors.empresa ||
              this.state.errors.empresa === 'required' ? (
                <FormControl error>
                  <FormHelperText>Campo obrigatório</FormHelperText>
                </FormControl>
              ) : (
                ''
              )
            ) : (
              <FormControl>
                <FormHelperText>&nbsp;</FormHelperText>
              </FormControl>
            )}
          </div>

          <div className='field'>
            <InputMask
              mask='99.999.999/9999-99'
              value={this.state.cnpj}
              disabled={false}
              maskChar=' '
              onChange={(evt) => this.handleCNPJ(evt.target.value)}
              autoComplete='off'
            >
              {() => (
                <TextField
                  variant='filled'
                  required
                  id='cnpj'
                  label='CNPJ'
                  name='cnpj'
                  autoFocus
                  fullWidth
                />
              )}
            </InputMask>
            {this.state.formSubmitted !== false ? (
              this.state.errors.cnpj !== false ? (
                <FormControl error>
                  {this.state.errors.cnpj === 'invalid' ? (
                    <FormHelperText>CNPJ inválido</FormHelperText>
                  ) : (
                    <FormHelperText>Campo obrigatório</FormHelperText>
                  )}
                </FormControl>
              ) : (
                ''
              )
            ) : (
              ''
            )}
          </div>

          <div className='field'>
            <FormControl variant='filled'>
              <InputLabel id='label-envios'>Envios por mês</InputLabel>
              <Select
                labelId='label-envios'
                id='envios'
                value={this.state.envio}
                onChange={(evt) => this.setState({ envio: evt.target.value })}
                fullWidth
              >
                {this.state.envios.map((envio) => (
                  <MenuItem key={envio.value} value={envio.value}>
                    {' '}
                    {envio.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        {/* Cargo | URL */}
        <div className='fields'>
          <div className='field'>
            <FormControl variant='filled'>
              <InputLabel id='label-cargo'>Cargo *</InputLabel>
              <Select
                labelId='label-cargo'
                id='cargo'
                value={this.state.cargo}
                onChange={(evt) => this.handleCargo(evt.target.value)}
                fullWidth
              >
                {this.state.cargos.map((cargo) => (
                  <MenuItem key={cargo.value} value={cargo.value}>
                    {' '}
                    {cargo.label}
                  </MenuItem>
                ))}
              </Select>
              {this.state.formSubmitted !== false ? (
                this.state.errors.cargo ||
                this.state.errors.cargo === 'required' ? (
                  <FormControl error>
                    <FormHelperText>Campo obrigatório</FormHelperText>
                  </FormControl>
                ) : (
                  ''
                )
              ) : (
                <FormControl>
                  <FormHelperText>&nbsp;</FormHelperText>
                </FormControl>
              )}
            </FormControl>
          </div>
          <div className='field'>
            <TextField
              variant='filled'
              id='url'
              label='URL do site'
              name='url'
              autoFocus
              fullWidth
              autoComplete='off'
              onChange={(evt) => this.setState({ url: evt.target.value })}
            />
          </div>
        </div>

        <div className='fields'>
          <div className='field'>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.termos}
                  onChange={() => this.handleTermos()}
                  name='termos'
                />
              }
              label={
                <label>
                  Aceito os{' '}
                  <a
                    href='https://www.mandae.com.br/termos-de-uso'
                    target='_blank'
                    rel='noreferrer'
                  >
                    termos de uso
                  </a>
                </label>
              }
            />
          </div>
        </div>
        <div className='fields'>
          <div className='field'>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.comunicados}
                  onChange={() => this.handleComunicados()}
                  name='comunicados'
                />
              }
              label='Aceito receber comunicados da Mandaê'
            />
          </div>
        </div>
        <button
          type='button'
          className='botao'
          onClick={() => this.enviarForm()}
        >
          Enviar
        </button>
      </Fragment>
    ) : (
      <Redirect to='sucesso' />
    );
  }

  render() {
    return this.renderData();
  }
}

export default MainPage;
